import { schema } from 'normalizr'

import copy from 'fast-copy'

// big fucken todo: consolidate all these processStrategies - they're all pretty much the same. 

// don't use processStrategy here, cause users + guests both have 'accounts' key.
export const userSchema = new schema.Entity('users', {}, {
	processStrategy: (entity, parent, key) => {
		if (entity.last_open_account_id) {

			let user = copy(entity);
			let userWithoutLastOpenAccountId = copy(user)

			delete userWithoutLastOpenAccountId.last_open_account_id

			user.account = {
				id: entity.last_open_account_id,
				users: [userWithoutLastOpenAccountId]
			}

			return user
		} else {
			return entity
		}
	}
})

export const guestSchema = new schema.Entity('guests', {}, {
	processStrategy: (entity, parent, key) => {
		if ((!key || key == 'activityable' || key == 'notifyable') && entity.last_open_account_id) {

			let user = copy(entity);

			user.account = {
				id: entity.last_open_account_id,
				users: [user]
			}

			return user;
		} else {
			return entity;
		}
	}
});

export const commentSchema = new schema.Entity('comments', {}, {
	processStrategy: (entity, parent, key) => {
		if (!key || key == 'activityable') {

			let comment = copy(entity);

			comment.task = {
				id: entity.task_id,
				comments: [entity]
			}

			return comment
		} else {
			return entity
		}
	}
});

export const messageSchema = new schema.Entity('messages', {}, {
	processStrategy: (entity, parent, key) => {
		if (!key) {
			let message = copy(entity)

			message.chat = {
				id: entity.chat_id,
				messages: [entity]
			}

			return message
		} else {
			return entity
		}
	}
});

export const chatSchema = new schema.Entity('chats', {}, {
	processStrategy: (entity, parent, key) => {
		if (!key) {
			let chat = copy(entity)

			if (chat.users) {
				chat.users.forEach(user => {
					user.chats = [entity]
				})
			}

			return chat
		} else {
			return entity
		}
	}
})

export const versionSchema = new schema.Entity('versions', {}, {
	processStrategy: (entity, parent, key) => {
		if (entity.task_id || entity.chat_id) {
			let version = copy(entity)
			let versionWithoutParentIds = copy(version)

			if (entity.task_id) {
				versionWithoutParentIds.task_id = null

				version.task = {
					id: entity.task_id,
					versions: [versionWithoutParentIds]
				}
			}

			if (entity.chat_id) {
				versionWithoutParentIds.chat_id = null

				version.chat = {
					id: entity.chat_id,
					versions: [versionWithoutParentIds]
				}
			}

			return version
		} else {
			return entity
		}
	}
});

export const fileSchema = new schema.Entity('files', {}, {
	processStrategy: (entity, parent, key) => {
		if (!key || key == 'activityable' || key == 'notifyable') {
			let file = copy(entity);
			let fileWithoutProjectId = copy(file)

			delete fileWithoutProjectId.project_id
			delete fileWithoutProjectId.task_id

			file.project = {
				id: entity.project_id,
				files: [fileWithoutProjectId]
			}

			if (file.task_id) {
				file.task = {
					id: entity.task_id,
					files: [fileWithoutProjectId]
				}
			}

			return file;
		} else {
			return entity;
		}
	}
})

export const file_folderSchema = new schema.Entity('file_folders', {}, {
	processStrategy: (entity, parent, key) => {
		if (!key || key == 'activityable') {
			let file = copy(entity)
			let fileFolderWithoutProjectId = copy(file)

			delete fileFolderWithoutProjectId.project_id

			file.project = {
				id: entity.project_id,
				file_folders: [fileFolderWithoutProjectId]
			}

			return file
		} else {
			return entity
		}
	}
})

export const taskSchema = new schema.Entity('tasks', {}, {
	processStrategy: (entity, parent, key) => {
		if (!key || key == 'activityable' || key == 'notifyable') {
			let task = copy(entity);

			// Only a directly-fetched task (!key) may assert its milestone's task
			// list. When a task arrives as an incidental reference — the `notifyable`
			// of a notification or the `activityable` of an activity — attaching
			// `tasks: [entity]` normalizes into a milestone that claims to contain
			// just this one task, which on an overwrite/hard-set merge wipes the
			// milestone's real task list down to 1. Keep the link, drop the claim.
			task.milestone = key
				? { id: entity.milestone_id }
				: { id: entity.milestone_id, tasks: [entity] }

			return task;
		} else {
			return entity;
		}
	}
});

export const invitationSchema = new schema.Entity('invitations', {}, {
	processStrategy: (entity, parent, key) => {
		if (entity.account_id) {
			let invitation = copy(entity)
			let invitationWithoutAccountId = copy(invitation)

			invitationWithoutAccountId.account_id = null
			invitationWithoutAccountId.project_id = null

			invitation.account = {
				id: invitation.account_id,
				invitations: [invitationWithoutAccountId]
			}

			if (invitation.projectIds.length && parent.instigator_id) {
				invitation.projects = []

				invitation.projectIds.forEach(projectId => {
					invitation.projects.push({
						id: projectId,
						guests: [parent.instigator_id],
						//guestIds: [parent.instigator_id]
					})
				})
			}

			return invitation
		} else {
			return entity
		}
	}
})

export const noteSchema = new schema.Entity('notes', {}, {
	processStrategy: (entity, parent, key) => {
		if (!key) {
			let note = copy(entity);

			note.project = {
				id: entity.project_id,
				notes: [entity]
			}

			return note;
		} else {
			return entity;
		}
	}
});

export const milestoneSchema = new schema.Entity('milestones', {}, {
	processStrategy: (entity, parent, key) => {
		if (!key || key == 'activityable' || key == 'notifyable') {
			let milestone = copy(entity);

			milestone.project = {
				id: entity.project_id,
				milestones: [entity]
			}

			if (entity.meeting_id) {
				milestone.meeting = {
					id: entity.meeting_id,
					milestone: entity
				}
			}

			return milestone
		} else {
			return entity
		}
	}
});

export const projectSchema = new schema.Entity('projects', {}, {
	processStrategy: (entity, parent, key) => {
		if ((!key || key == 'activityable') && entity.account_id) {
			let project = copy(entity)

			let projectWithoutParentIds = copy(project)

			delete projectWithoutParentIds.account_id
			delete projectWithoutParentIds.folder_id

			project.account = {
				id: project.account_id,
				projects: [projectWithoutParentIds]
			}

			if ((key == 'activityable' && parent.fromSocket)) {
				project.folder = {
					id: project.folder_id,
					projects: [projectWithoutParentIds]
				}
			}

			return project
		} else {
			return entity
		}
	}
})

export const statusSchema = new schema.Entity('statuses', {}, {})

export const folderSchema = new schema.Entity('folders', {}, {
	processStrategy: (entity, parent, key) => {
		if (!key || key == 'activityable') {
			let folder = copy(entity)

			folder.parent_folder = {
				id: entity.folder_id,
				folders: [entity]
			}

			if (!folder.projects) {
				folder.projects = []
			}

			return folder
		} else {
			return entity
		}
	}
})



export const teamSchema = new schema.Entity('teams', {}, {
	processStrategy: (entity, parent, key) => {
		if (!key || key == 'activityable' || key == 'notifyable') {
			let team = copy(entity)

			team.account = {
				id: entity.account_id,
				teams: [entity]
			}

			return team
		} else {
			return entity
		}
	}
})

export const itemSchema = new schema.Union({
	projects: projectSchema,
	tasks: taskSchema,
}, (value, parent) => {
	let schemaAttribute = parent.item_type.replace('App\\', '').toLowerCase() + 's'
	return schemaAttribute;
})

export const historyItemSchema = new schema.Entity('history_items', {
	item: itemSchema,
	//user: userSchema
}, {
	/* processStrategy: (entity, parent, key) => {
		if(!key){
			let historyItem = copy(entity);

			historyItem.user = {
				id: entity.user_id,
				history_items: [entity]
			}

			return historyItem;
		}else{
			return entity;
		}
	} */
})

export const accountSchema = new schema.Entity('accounts', {})

export const sessionSchema = new schema.Entity('sessions', {
	user: userSchema,
	task: taskSchema
}, {
	processStrategy: (entity, parent, key) => {
		if (!key || key == 'activityable') {
			let session = copy(entity)

			if (!session.user) {
				session.user = {
					id: entity.user_id,
					sessions: [entity]
				}
			}

			session.task = {
				id: entity.task_id,
				sessions: [entity]
			}

			session.project = {
				id: entity.project_id,
				sessions: [entity]
			}

			return session
		} else {
			return entity
		}
	}
})

export const bulletinSchema = new schema.Entity('bulletins', {}, {
	processStrategy: (entity, parent, key) => {
		if (!key || key == 'activityable' || key == 'notifyable') {
			let bulletin = copy(entity)

			bulletin.user = {
				id: entity.user_id,
				bulletins: [entity]
			}

			bulletin.account = {
				id: entity.account_id,
				bulletins: [entity]
			}

			return bulletin
		} else {
			return entity
		}
	}
})

export const eventSchema = new schema.Entity('events', {}, {
	processStrategy: (entity, parent, key) => {
		if (!key || key == 'activityable' || key == 'notifyable') {
			let event = copy(entity)

			event.user = {
				id: entity.user_id,
				events: [entity]
			}

			event.account = {
				id: entity.account_id,
				events: [entity]
			}

			return event
		} else {
			return entity
		}
	}
})



export const checklist_itemSchema = new schema.Entity('checklist_items', {}, {
	processStrategy: (entity, parent, key) => {
		if (!key || key == 'activityable') {
			const checklistItem = copy(entity)

			checklistItem.task = {
				id: checklistItem.task_id,
				checklist_items: [entity]
			}

			return checklistItem
		} else {
			return entity
		}
	}
})

export const chatSearchResultSchema = new schema.Entity('chat_search_results', {})

export const activityableSchema = new schema.Union({
	comments: commentSchema,
	tasks: taskSchema,
	projects: projectSchema,
	folders: folderSchema,
	notes: noteSchema,
	milestones: milestoneSchema,
	files: fileSchema,
	versions: versionSchema,
	users: userSchema,
	guests: userSchema,
	accounts: accountSchema,
	teams: teamSchema,
	sessions: sessionSchema,
	bulletins: bulletinSchema,
	events: eventSchema,
	checklistitems: checklist_itemSchema,
	filefolders: file_folderSchema
}, (value, parent) => {
	const schemaAttribute = parent.activityable_type.replace('App\\', '').toLowerCase() + 's'

	return schemaAttribute
})

export const activitySchema = new schema.Entity('activities', {
	activityable: activityableSchema
})

export const progressUpdateSchema = new schema.Entity('progress_updates', {
	project: projectSchema,
	account: accountSchema
}, {
	processStrategy: (entity, parent, key) => {
		if (!key || key == 'activityable' || key == 'notifyable') {
			let progressUpdate = copy(entity)

			progressUpdate.project = {
				id: entity.project_id,
				progress_updates: [entity]
			}

			return progressUpdate
		} else {
			return entity
		}
	}

})

export const notifyableSchema = new schema.Union({
	comment: commentSchema,
	task: taskSchema,
	project: projectSchema,
	team: teamSchema,
	invitation: invitationSchema,
	bulletin: bulletinSchema,
	event: eventSchema
}, (value, parent) => {
	let schemaAttribute = parent.notifyable_type.replace('App\\', '').toLowerCase()
	return schemaAttribute
})

export const targetSchema = new schema.Union({
	comments: commentSchema,
	tasks: taskSchema,
	projects: projectSchema,
	teams: teamSchema
}, (value, parent) => {
	let schemaAttribute = parent.target_type.replace('App\\', '').toLowerCase() + 's'
	return schemaAttribute
})

export const notificationSchema = new schema.Entity('notifications', {
	notifyable: notifyableSchema,
	notifyableParent: taskSchema,
	recipient: userSchema,
	instigator: userSchema,
	target: targetSchema,
	account: accountSchema
}, {
	processStrategy: (entity, parent, key) => {
		if (!key) {
			let notification = copy(entity)

			notification.recipient = {
				id: entity.recipient_id,
				notifications: [entity]
			}

			return notification
		} else {
			return entity
		}
	}
})

export const todoSchema = new schema.Entity('todos');

export const todoDaySchema = new schema.Entity('todo_days', {}, {
	processStrategy: (entity, parent, key) => {
		if (!key) {
			let todoDay = copy(entity)

			todoDay.user = {
				id: entity.user_id,
				todo_days: [entity]
			}

			return todoDay
		} else {
			return entity
		}
	}
})

export const dashboardDataSchema = new schema.Entity('dashboardData', {}, {
	processStrategy: (entity, parent, key) => {
		return entity
	}
})

export const dashboardQuerySchema = new schema.Entity('dashboardQuery', {})

export const searchDataSchema = new schema.Entity('searchData', {})

export const chatObjectSchema = new schema.Union({
	message: messageSchema,
	version: versionSchema,
}, (value, parent) => {
	if (!parent) {
		return
	}
	let schemaAttribute = parent.item_type.replace('App\\', '').toLowerCase()
	return schemaAttribute
})

export const chatItemSchema = new schema.Entity('chat_items', {
	object: chatObjectSchema,
	chat: chatSchema
}, {
	processStrategy: (entity, parent, key) => {
		if (!key) {
			let chatItem = copy(entity)

			chatItem.chat = {
				id: entity.chat_id,
				chat_items: [entity]
			}

			return chatItem
		} else {
			return entity
		}
	}
})

export const meetingSchema = new schema.Entity('meetings', {}, {
	processStrategy: (entity, parent, key) => {
		if (!key || key == 'activityable' || key == 'notifyable') {
			let meeting = copy(entity)

			meeting.project = {
				id: entity.project_id,
				meetings: [entity]
			}

			return meeting
		} else {
			return entity
		}
	}
})

export const stakeholderSchema = new schema.Entity('stakeholders', {
	meetings: [meetingSchema],
	organised_meetings: [meetingSchema],
	account: accountSchema
}, {
	processStrategy: (entity, parent, key) => {
		if (!key) {
			const stakeholder = copy(entity)

			stakeholder.account = {
				id: stakeholder.account_id,
				stakeholders: [entity]
			}

			return stakeholder
		} else {
			return entity
		}
	}
})

export const purposeSchema = new schema.Entity('purposes', {
	account: accountSchema,
	meetings: [meetingSchema]
}, {
	processStrategy: (entity, parent, key) => {
		if (!key || parent.account_id) {
			const purpose = copy(entity)

			purpose.account = {
				id: purpose.account_id,
				purposes: [entity]
			}

			return purpose
		} else {
			return entity
		}
	}
})

export const attendantSchema = new schema.Entity('attendants', {
	account: accountSchema,
	notes: [noteSchema]
}, {
	processStrategy: (entity, parent, key) => {
		if (!key) {
			const attendant = copy(entity)

			attendant.account = {
				id: attendant.account_id,
				attendants: [entity]
			}

			return attendant
		} else {
			return entity
		}
	}
})

export const missingSchema = new schema.Entity('missings', {
	tasks: [taskSchema],
	milestones: [milestoneSchema],
	projects: [projectSchema],
	users: [userSchema],
	versions: [versionSchema],
	chatItems: [chatItemSchema]
})

export const invoiceSchema = new schema.Entity('invoices', {
	account: accountSchema
})

export const columnSchema = new schema.Entity('columns', {
	project: projectSchema
})

teamSchema.define({
	users: [userSchema],
	projects: [projectSchema],
	account: accountSchema,
	activity_items: [activitySchema],
	chat: chatSchema
})

checklist_itemSchema.define({
	task: taskSchema,
	user: userSchema
})

bulletinSchema.define({
	user: userSchema,
	account: accountSchema
})

eventSchema.define({
	user: userSchema,
	account: accountSchema
})

accountSchema.define({
	folders: [folderSchema],
	guests: [userSchema],
	projects: [projectSchema],
	invitations: [invitationSchema],
	users: [userSchema],
	activity_items: [activitySchema],
	teams: [teamSchema],
	bulletins: [bulletinSchema],
	events: [eventSchema],
	stakeholders: [stakeholderSchema],
	purposes: [purposeSchema],
	meetings: [meetingSchema],
	attendants: [attendantSchema],
	invoices: [invoiceSchema],
	statuses: [statusSchema],
	quickTasks: [taskSchema]
})

const userSchemaDefinition = {
	account: accountSchema,
	chats: [chatSchema],
	notifications: [notificationSchema],
	accounts: [accountSchema],
	guest_accounts: [accountSchema],
	todo_days: [todoDaySchema],
	history_items: [historyItemSchema],
	activity_items: [activitySchema],
	sessions: [sessionSchema],
	teams: [teamSchema],
	tasks: [taskSchema],
	bulletins: [bulletinSchema],
	events: [eventSchema],
	checklist_items: [checklist_itemSchema]
}
//////
userSchema.define(userSchemaDefinition)
guestSchema.define(userSchemaDefinition)

chatSchema.define({
	messages: [messageSchema],
	users: [userSchema],
	versions: [versionSchema],
	chat_items: [chatItemSchema],
	search_results: [chatSearchResultSchema],
	team: teamSchema
})

chatSearchResultSchema.define({
	chat_items: [chatItemSchema]
})

messageSchema.define({
	chat: chatSchema,
	chat_item: [chatItemSchema],
	replying_to: messageSchema
})

invitationSchema.define({
	account: accountSchema,
	projects: [projectSchema]
})

projectSchema.define({
	account: accountSchema,
	invitations: [invitationSchema],
	milestones: [milestoneSchema],
	archivedMilestones: [milestoneSchema],
	notes: [noteSchema],
	files: [fileSchema],
	folder: folderSchema,
	guests: [userSchema],
	activity_items: [activitySchema],
	teams: [teamSchema],
	sessions: [sessionSchema],
	progress_updates: [progressUpdateSchema],
	meetings: [meetingSchema],
	file_folders: [file_folderSchema],
	tasks: [taskSchema]
})

fileSchema.define({
	versions: [versionSchema],
	project: projectSchema,
	task: taskSchema,
	file_folder: file_folderSchema
})

versionSchema.define({
	user: userSchema,
	task: taskSchema,
	chat: chatSchema,
	file: fileSchema
})

file_folderSchema.define({
	files: [fileSchema],
	file_folder: file_folderSchema,
	file_folders: [file_folderSchema],
	project: projectSchema
})

noteSchema.define({
	project: projectSchema,
	attendants: [attendantSchema],
	mentions: [userSchema]
})

taskSchema.define({
	users: [userSchema],
	comments: [commentSchema],
	files: [fileSchema],
	versions: [versionSchema],
	milestone: milestoneSchema,
	created_by: userSchema,
	sessions: [sessionSchema],
	checklist_items: [checklist_itemSchema],
	project: projectSchema,
	quickTaskParent: accountSchema
})

commentSchema.define({
	task: taskSchema,
	user: userSchema
})

milestoneSchema.define({
	tasks: [taskSchema],
	project: projectSchema,
	archivedTasks: [taskSchema],
	meeting: meetingSchema
})

folderSchema.define({
	projects: [projectSchema],
	folders: [folderSchema],
	parent_folder: folderSchema
})

todoDaySchema.define({
	todos: [todoSchema],
	user: userSchema
})

todoSchema.define({
	todo_day: todoDaySchema,
	task: taskSchema
})

dashboardDataSchema.define({
	upcomingTasks: [taskSchema],
	recentlyAddedTasks: [taskSchema],
	projects: [projectSchema],
})

dashboardQuerySchema.define({
	recentlyAdded: [taskSchema],
	upcoming: [taskSchema]
})

searchDataSchema.define({
	files: [fileSchema],
	comments: [commentSchema],
	milestones: [milestoneSchema],
	notes: [noteSchema],
	projects: [projectSchema],
	tasks: [taskSchema],
	users: [userSchema]
})

meetingSchema.define({
	project: projectSchema,
	organiser: userSchema,
	stakeholder: stakeholderSchema,
	stakeholders: [stakeholderSchema],
	purposes: [purposeSchema],
	milestone: milestoneSchema
})